import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ReplaySubject, Subject } from 'rxjs';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { ReportService } from './report.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { takeUntil } from 'rxjs/operators';
import { Board, GrievanceType, Departments } from '../../interface/common-interface';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { ProjectConstants } from '../../project-constants';
import { CommonFunction } from '../../common-function';
import { Router } from '@angular/router';

const COLS = [
  { value: "GRIEVANCE ID", lowercaseValue: "Grievance_ID", displayName: "Grievance Id" },
  { value: "CREATED DATE", lowercaseValue: "Created_Date", displayName: "Created Date" },
  { value: "BOARD", lowercaseValue: "Board", displayName: "Board" },
  { value: "DEPARTMENT", lowercaseValue: "Department", displayName: "Department" },
  { value: "GRIEVANCE TYPE", lowercaseValue: "Grievance_Type", displayName: "Grievance Type" },
  { value: "STATUS", lowercaseValue: "Status", displayName: "Status" },
];
export class GrievanceList {
  Grievance_ID: any;
  Board: any;
  Grievance_Type: any;
  Subject: string;
  Created_Date: any;
  updatedOn: any;
  Status: any;
  Description: any
  Department: any
  UserName: any
  UserMobileNo: any
  UserEmail: any
  UserPan:any
  UserType: any
  assignedToName: any
  assigedToDate: any
  escalateDate: any
  esacalateToName: any
  tranferredDate: any
  trasferredBoard: any
  trasferredDep: any
  trasferredGrivType: any
  trasferredRemark: any
  trasferredToUser: any
}
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  displayedCols = COLS;
  serachCtrl: FormControl = new FormControl();
  allCols = COLS;
  displayedColumns: any[];
  userLists: any = [];
  grievanceList: GrievanceList[] = [];
  filterOptions: any[] = [];
  selectedFilterOption: any = null;
  phoneNumberVisible: boolean = false;
  emailVisible: boolean = false;
  phoneNo: any;
  emaild: any;
  grievancenoData = ProjectConstants.grievanceNotAvailable;
  noDataFoundEr: boolean = false
  isShowTable: boolean = false;
  dataSource = new MatTableDataSource(this.grievanceList);
  progressSpinnerDialog: any = null;

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  protected _onDestroy = new Subject<void>();

  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);

  protected grievance: GrievanceType[] = [];
  public grievanceCtrl: FormControl = new FormControl();
  public grievanceFilterCtrl: FormControl = new FormControl();
  public filteredGrievance: ReplaySubject<GrievanceType[]> = new ReplaySubject<GrievanceType[]>(1);

  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);

  reportTypes: any = []

  constructor(public reportService: ReportService,
    public _formBuilder: FormBuilder,
    public datepipe: DatePipe,
    public router: Router,
    private commonFunction: CommonFunction,
    public dialog: MatDialog
  ) { }

  isSubmitDisabled: boolean = false;
  showError: boolean = false
  showFormEr: boolean = false
  firstFormGroup = this._formBuilder.group({
    grievanceCtrl: [0],
    departmentCtrl: [0],
    boardCtrl: [0, [Validators.required]],
    reportCtrl: ['All'],
    fromCtrl: ['', [Validators.required]],
    toCtrl: ['', [Validators.required]],
    // radioCtrl: ['WithoutAuditTrail', [Validators.required]],
  })

  async ngOnInit() {
    this.displayedCols = [
      { value: "GRIEVANCE ID", lowercaseValue: "Grievance_ID", displayName: "Grievance Id" },
      { value: "CREATED DATE", lowercaseValue: "Created_Date", displayName: "Created Date" },
      { value: "BOARD", lowercaseValue: "Board", displayName: "Board" },
      { value: "DEPARTMENT", lowercaseValue: "Department", displayName: "Department" },
      { value: "GRIEVANCE TYPE", lowercaseValue: "Grievance_Type", displayName: "Grievance Type" },
      // { value: "SUBJECT", lowercaseValue: "Subject", displayName: "Subject" },
      { value: "STATUS", lowercaseValue: "Status", displayName: "Status" },
    ];
    this.reportTypes = [
      { 'value': "All" },
      { 'value': "Escalated" },
      { 'value': "Transferred" },
    ]
    this.dataSource.paginator = this.paginator;
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.displayProgressSpinner();
    const response: any = await this.reportService.loadBoard();
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {  
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.boards = response
        //set boards in array  
        this.boardCtrl.setValue(this.boards[10]);
        this.filteredboards.next(this.boards.slice());
        this.boardFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterboards();
          });
        //
      } else if (response[0].status ==ProjectConstants.responseStatusFailure) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")

    }
    //
  }

  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(
      this.boards.filter(board => board.boardName.toLowerCase().indexOf(search) > -1)
    );
  }
  //


  // select board dependant on grievance type
  async selectBoard(boards: any) {
    if (boards != 0) {
      this.displayProgressSpinner();
      const response: any = await this.reportService.loadDepartments(boards);
      if (response != null && !response.error) {
        this.departments = []
        this.grievance = []
        this.progressSpinnerDialog.close()
        if (response.length != 0) {
          if (response[0].status == ProjectConstants.responseStatusSuccess) {
            this.departments = response;
            this.departmentCtrl.setValue(this.departments[10]);
            this.filteredDepartment.next(this.departments.slice());
            this.departmentFilterCtrl.valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filtereDepartments();
              })
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
          }
        } else {
          this.departments = []
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }


      this.departmentCtrl.setValue(this.departments[10]);
      this.filteredDepartment.next(this.departments.slice());
      this.departmentFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filtereDepartments();
        })
      this.grievanceCtrl.setValue(this.grievance[10]);
      this.filteredGrievance.next(this.grievance.slice());
      this.grievanceFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filtereGrievances();
        })
    }
  }


  //department type filter
  protected filtereDepartments() {
    if (!this.departments) {
      return;
    }
    let search = this.departmentFilterCtrl.value;
    if (!search) {
      this.filteredDepartment.next(this.departments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepartment.next(
      this.departments.filter(department => department.departmentName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  async selectDepartment(dept: any) {
    if (dept != 0) {
      this.displayProgressSpinner();
      const response: any = await this.reportService.loadGrievance(dept,this.firstFormGroup.controls['boardCtrl'].value);
      if (response != null && !response.error) {
        this.grievance = []
        this.progressSpinnerDialog.close()
        if (response.length != 0) {
          if (response[0].status == ProjectConstants.responseStatusSuccess) {
            this.grievance = response;
            this.grievanceCtrl.setValue(this.grievance[10]);
            this.filteredGrievance.next(this.grievance.slice());
            this.grievanceFilterCtrl.valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filtereGrievances();
              })
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
          }
        } else {
          this.grievance = []
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
      this.grievanceCtrl.setValue(this.grievance[10]);
      this.filteredGrievance.next(this.grievance.slice());
      this.grievanceFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filtereGrievances();
        })
    }
  }


  // grievance type filter
  protected filtereGrievances() {
    if (!this.grievance) {
      return;
    }
    let search = this.grievanceFilterCtrl.value;
    if (!search) {
      this.filteredGrievance.next(this.grievance.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredGrievance.next(
      this.grievance.filter(grievance => grievance.gtGrievanceType.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  async searchReport() {
    this.displayProgressSpinner();
    const response1: any = await this.reportService.loadGrievances()
    this.progressSpinnerDialog.close();
    if (response1 != null && !response1.error) {
      if (response1[0].status == ProjectConstants.responseStatusSuccess) {
        this.grievanceList = []
        for (var i = 0; i < response1.length; i++) {
          // var created_date = response1[i].createdOn
          var created_date = (response1[i].createdOn!=null && response1[i].createdOn.includes("+"))?response1[i].createdOn.split("+")[0]:response1[i].createdOn

          let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
          const customObj = new GrievanceList();
          customObj.Grievance_ID = response1[i].pkUsgrid
          customObj.Created_Date = created_on
          customObj.UserName = response1[i].userName
          customObj.UserMobileNo = response1[i].userMobileNo
          customObj.UserEmail = response1[i].userEmail
          if (response1[i].usGriUserType == "MU") {
            customObj.UserType = ProjectConstants.userTypeMhadaUser
          } else if (response1[i].usGriUserType == "LU") {
            customObj.UserType = ProjectConstants.userTypeLotteryUser
          }
          customObj.Board = response1[i].boardName
          customObj.Department = response1[i].departmentName
          customObj.Grievance_Type = response1[i].grivType
          customObj.Subject = response1[i].usGriSubject
          customObj.Description = response1[i].usGriDetails
          customObj.Status = response1[i].statusName
          this.grievanceList.push(customObj)
        }
        this.dataSource.data = this.grievanceList;
        this.displayedColumns = this.displayedCols.map((col) => col.value);
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      this.grievanceList = []
    }
  }


  // async errorToast() {
  //   await this._snackBar.open(ProjectConstants.networkErMsg,
  //     "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "error-toast",
  //     duration: 3 * 1000,
  //   });
  // }

  //progress bar
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  onDownloadClick() {
    var title;
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Grievance Report');
    var header;
    var filename;
    if (this.firstFormGroup.controls['reportCtrl'].value == "All") {
      title = 'All Grievance Report'
      header = ["Grievance Id", "Created Date", "Username", "Mobile No.", "Email","Pan No.", "Type of user", "Board", "Department", "Grievance Type", "Subject", "Description", "Status", "Assign To Name","Assign To Date","Last Updated Date"]
      // worksheet.mergeCells('A1:W1');
      filename = "All Grievance Report"
    } else if (this.firstFormGroup.controls['reportCtrl'].value == "Escalated") {
      title = "Escalated Grievance Report"
      filename = "Escalated Grievance Report"
      // worksheet.mergeCells('A1:P1');
      header = ["Grievance Id", "Created Date", "Username", "Mobile No.", "Email","Pan No.", "Type of user", "Board", "Department", "Grievance Type", "Subject", "Description", "Status", "Assign To Name","Assign To Date", "Escalate Date", "Escalate To Name", "Last Updated Date"]
    }
    else {
      title = "Transferred Grievance Report"
      filename = "Transferred Grievance Report"
      // worksheet.mergeCells('A1:P1');
      header = ["Grievance Id", "Created Date", "Username", "Mobile No.", "Email","Pan No.", "Type of user", "Board", "Department", "Grievance Type", "Subject", "Description", "Status","Assign To Name","Assign To Date", "Transferred Date", "Transferred Board", "Transferred Deaprtment", "Type of Grievance", "Transfer Remark", "Transfer to", "Last Updated Date"]
    }
    
    let titleRow = worksheet.addRow([title]);
    titleRow.font = {
      name: 'Times New Roman',
      size: 16,
      underline: 'single',
      bold: true,
    }
    if (this.firstFormGroup.controls['reportCtrl'].value == "All") {
     worksheet.mergeCells('A1:O1');

    } else if (this.firstFormGroup.controls['reportCtrl'].value == "Escalated") {
      worksheet.mergeCells('A1:Q1');
    }
    else {
      worksheet.mergeCells('A1:U1');
    }
    worksheet.addRow([]);
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808080' },
      }
      cell.font = {
        name: 'Arial',
        family: 2,
        bold: true,
        size: 10,
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    });
    const list = []

    this.grievanceList.forEach((row: any) => {
      list.push(Object.values(row))
    })

    list.forEach(d => {
      let row = worksheet.addRow(d);
    });

    for (var i = 1; i <= header.length; i++) {
      const dobCol = worksheet.getColumn(i);
      dobCol.eachCell({ includeEmpty: false }, function (cell, rowNumber) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      });
      if (i == 3) {
        worksheet.getColumn(i).width = 30;
        worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      } else if (i == 10 || i == 11) {
        worksheet.getColumn(i).width = 50;
        worksheet.getColumn(i).alignment = { vertical: 'justify', horizontal: 'left', wrapText: true }
      } else if (i == 5) {
        worksheet.getColumn(i).width = 40;
        worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      } else {
        worksheet.getColumn(i).width = 20;
        worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      }
    }
    titleRow.border =
    {
      top: { style: 'thin', color: { argb: 'FFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFF' } }
    }
   
    titleRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    headerRow.height = 35;


    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, filename + '.xlsx');
    });
  }

  formDateChanged() {
    if (this.firstFormGroup.controls['toCtrl'].value != '') {
      this.firstFormGroup.patchValue({
        toCtrl: "",

      });
    }
  }
  valueChanged() {
    this.showFormEr = false
    if (this.firstFormGroup.controls['fromCtrl'].value == '') {
      this.showFormEr = true
    }
    var date = this.calculateDiff(this.firstFormGroup.controls['fromCtrl'].value, this.firstFormGroup.controls['toCtrl'].value)
    this.showError = false
    if (date < -1) {
      this.showError = true
    }
  }

  calculateDiff(current, dateSent) {
    let currentDate = new Date(dateSent);
    dateSent = new Date(current);
    return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())) / (1000 * 60 * 60 * 24));
  }

  async submitForm() {
    if (this.firstFormGroup.valid && !this.showError) {
      const fromDate = this.datepipe.transform(this.firstFormGroup.controls['fromCtrl'].value, 'yyyy-MM-dd 00:00:00');
      const toDate = this.datepipe.transform(this.firstFormGroup.controls['toCtrl'].value, 'yyyy-MM-dd 23:59:59');
      var gtid = null
      if (this.firstFormGroup.controls['grievanceCtrl'].value != 0) {
        gtid = this.firstFormGroup.controls['grievanceCtrl'].value
      }
      var depId = null
      if (this.firstFormGroup.controls['departmentCtrl'].value != 0) {
        depId = this.firstFormGroup.controls['departmentCtrl'].value
      }
      var boardId = null
      if (this.firstFormGroup.controls['boardCtrl'].value != 0) {
        boardId = this.firstFormGroup.controls['boardCtrl'].value
      }
      const data = {
        'fkGtId': gtid,
        'fkDepid': depId,
        'fkBdid': boardId,
        fromDate: fromDate,
        toDate: toDate,
        'reportType': this.firstFormGroup.controls['reportCtrl'].value
        // radioCtrl:this.firstFormGroup.controls['radioCtrl'].value,
      }
      this.displayProgressSpinner();
      this.noDataFoundEr = false
      const response1: any = await this.reportService.selectDetailsForReport(data)
      this.progressSpinnerDialog.close()
      if (response1 != null && !response1.error) {   
        this.noDataFoundEr = true
        if (response1.length != 0) {
          if (response1[0].status == ProjectConstants.responseStatusSuccess) {
            this.grievanceList = []
            for (var i = 0; i < response1.length; i++) {
              var created_date = (response1[i].createdOn!=null && response1[i].createdOn.includes("+"))?response1[i].createdOn.split("+")[0]:response1[i].createdOn
              let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
              const customObj = new GrievanceList();
              customObj.Grievance_ID = response1[i].pkUsgrid
              customObj.Created_Date = created_on
              customObj.UserName = response1[i].userName
              customObj.UserMobileNo = response1[i].userMobileNo
              customObj.UserEmail = response1[i].userEmail
              customObj.UserPan= response1[i].userPanNo
              if (response1[i].usGriUserType == "MU") {
                customObj.UserType = ProjectConstants.userTypeMhadaUser
              } else if (response1[i].usGriUserType == "LU") {
                customObj.UserType = ProjectConstants.userTypeLotteryUser
              }
              customObj.Board = response1[i].boardName
              customObj.Department = response1[i].departmentName
              customObj.Grievance_Type = response1[i].grivType
              customObj.Subject = response1[i].usGriSubject
              customObj.Description = response1[i].usGriDetails
              customObj.Status = response1[i].statusName
              customObj.assignedToName = response1[i].assigeToName

              var assignDate = (response1[i].assigedToDate!=null && response1[i].assigedToDate.includes("+"))?response1[i].assigedToDate.split("+")[0]:response1[i].assigedToDate

              customObj.assigedToDate =this.datepipe.transform(assignDate, 'dd/MM/yyyy hh:mm a') 
              if (this.firstFormGroup.controls['reportCtrl'].value == "Escalated") {
                // var usEscDate = response1[i].usEscDate
                var usEscDate = (response1[i].usEscDate!=null && response1[i].usEscDate.includes("+"))?response1[i].usEscDate.split("+")[0]:response1[i].usEscDate
                let usEsc_Date = this.datepipe.transform(usEscDate, 'dd/MM/yyyy hh:mm a');
                customObj.escalateDate =this.datepipe.transform(usEsc_Date, 'dd/MM/yyyy hh:mm a') 
                customObj.esacalateToName = response1[i].esculateToName
              } else if(this.firstFormGroup.controls['reportCtrl'].value == "Transferred") {
                // var trasferredDate = response1[i].trasferredDate

                var trasferredDate = (response1[i].trasferredDate!=null && response1[i].trasferredDate.includes("+"))?response1[i].trasferredDate.split("+")[0]:response1[i].trasferredDate
                 customObj.tranferredDate =this.datepipe.transform(trasferredDate, 'dd/MM/yyyy hh:mm a')  
                customObj.trasferredBoard = response1[i].trasferredBoard
                customObj.trasferredDep = response1[i].trasferredDep
                customObj.trasferredGrivType = response1[i].trasferredGrivType
                customObj.trasferredRemark = response1[i].trasferredRemark
                customObj.trasferredToUser = response1[i].trasferredToUser
              }

              var updatedDate = (response1[i].updatedOn!=null && response1[i].updatedOn.includes("+"))?response1[i].updatedOn.split("+")[0]:response1[i].updatedOn

              customObj.updatedOn =this.datepipe.transform(updatedDate, 'dd/MM/yyyy hh:mm a')   
              this.grievanceList.push(customObj)
            }
            console.log("TTTTTTTTTTTT ", this.grievanceList)
            this.dataSource.data = this.grievanceList;
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
          }
        } else {
          this.grievanceList = []
          this.dataSource.data = this.grievanceList;
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        this.grievanceList = []
      }
    } else {
      this.isSubmitDisabled = false
    }
  }

  goToGrievanceView(grievanceId: any) {
      console.log("grievanceId",grievanceId);
    this.router.navigate(['secure/master-grievance-view/' + grievanceId])
  }
}
